import { render, staticRenderFns } from "./addProject.vue?vue&type=template&id=9fa56238&scoped=true"
import script from "./addProject.vue?vue&type=script&lang=js"
export * from "./addProject.vue?vue&type=script&lang=js"
import style0 from "./addProject.vue?vue&type=style&index=0&id=9fa56238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa56238",
  null
  
)

export default component.exports